/**
 * Звук о новом уведомлении в открытой вкладке. Без файла: два коротких тона
 * через Web Audio. Браузер даёт звучать только после нажатия на странице
 * (после перезагрузки — снова): до него сигнал молчит, карточка остаётся.
 */

let context: AudioContext | null = null

function unlock() {
  if (typeof AudioContext === 'undefined') return
  context ??= new AudioContext()
  void context.resume().catch(() => undefined)
}

/** Нажатие на этой странице уже было — например, на форме входа. */
function activated(): boolean {
  return 'userActivation' in navigator && navigator.userActivation.hasBeenActive
}

/** Готовим звук: сразу, если нажимали, иначе — к первому нажатию. Возвращает отписку. */
export function prepareChime(): () => void {
  if (activated()) unlock()
  window.addEventListener('click', unlock, { once: true })
  window.addEventListener('keydown', unlock, { once: true })
  return () => {
    window.removeEventListener('click', unlock)
    window.removeEventListener('keydown', unlock)
  }
}

function ring(ctx: AudioContext) {
  const start = ctx.currentTime
  ;[880, 1320].forEach((frequency, i) => {
    const at = start + i * 0.16
    const tone = ctx.createOscillator()
    const gain = ctx.createGain()
    tone.type = 'sine'
    tone.frequency.value = frequency
    gain.gain.setValueAtTime(0.0001, at)
    gain.gain.exponentialRampToValueAtTime(0.25, at + 0.02)
    gain.gain.exponentialRampToValueAtTime(0.0001, at + 0.3)
    tone.connect(gain).connect(ctx.destination)
    tone.start(at)
    tone.stop(at + 0.32)
  })
}

/**
 * Сигнал «пришло уведомление»; без разрешения браузера — тихо ничего.
 * Контекст, который браузер приостановил (сменился выход звука), будим.
 */
export function playChime(): void {
  const ctx = context
  if (!ctx) return
  if (ctx.state === 'running') ring(ctx)
  else if (activated())
    void ctx
      .resume()
      .then(() => {
        ring(ctx)
      })
      .catch(() => undefined)
}
